import React, { Component } from 'react';
import { Card, Button, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Fetcher } from '../../../Helpers/fetcher.js';
import { Notify } from '../../../Helpers/notification.js';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

class SheetContentList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sheetList: [],
			loading: true,
			sizePerPage: 10,
			confirmDelete: false,
			selectedId: null
		}
	}

	componentDidMount() {
		if (this.props.app.role !== 'ROLE_SADMIN' && this.props.app.role !== 'ROLE_SUB_SADMIN') {
			this.props.history.replace('/');
			return;
		}
		this.getSheetContentList();
		const savedSizePerPage = Cookies.get('sheetContentListSizePerPage');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}
	}

	getSheetContentList = () => {
		const apiPath = this.props.app.apiPath;
		const userId = this.props.app.userId;
		this.setState({ loading: true });
		Fetcher.get(apiPath + '/api/obd/sheet/content/list/' + userId)
			.then(res => {
				this.setState({ sheetList: Array.isArray(res) ? res : [] });
			})
			.catch(err => {
				console.log('Error in fetching Sheet Content List', err);
				Notify.notify('Error in fetching Sheet Content List');
			})
			.finally(() => this.setState({ loading: false }));
	}

	confirmDelete = (status, id) => {
		this.setState({ confirmDelete: status, selectedId: id });
	}

	deleteSheet = () => {
		const apiPath = this.props.app.apiPath;
		const data = { id: this.state.selectedId };
		Fetcher.post(apiPath + '/api/obd/sheet/content/delete', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.setState({ confirmDelete: false, selectedId: null });
				this.getSheetContentList();
			})
			.catch(err => {
				console.log('Error in deleting Sheet Content', err);
				Notify.notify('Error in deleting Sheet Content');
			});
	}

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('sheetContentListSizePerPage', newSizePerPage);
	}

	render() {
		const urlPrefix = this.props.app.urlPrefix || '';
		const columns = [
			{ dataField: 'id', text: 'Id', sort: true },
			{ dataField: 'sheetName', text: 'Sheet Name', sort: true, searchable: true },
			{ dataField: 'createdByName', text: 'Created By', sort: true },
			{ dataField: 'createdAt', text: 'Created At', sort: true },
			{ dataField: 'updatedAt', text: 'Updated At', sort: true },
			{ dataField: 'visibility', text: 'Visibility', sort: true },
			{
				dataField: 'action',
				text: 'Action',
				isDummyField: true,
				csvExport: false,
				formatter: (_, row) => (
					<>
						<Link to={`${urlPrefix}/superadmin-api-docs/sheet-content/view/${row.id}`} className="btn btn-primary btn-sm mr-1">View</Link>
						<Link to={`${urlPrefix}/superadmin-api-docs/sheet-content/edit/${row.id}`} className="btn btn-secondary btn-sm mr-1">Edit</Link>
						<Button variant="danger" size="sm" onClick={() => this.confirmDelete(true, row.id)}>Delete</Button>
					</>
				)
			}
		];

		const sheets = Array.isArray(this.state.sheetList) ? this.state.sheetList.map(s => ({
			id: s.id,
			sheetName: s.sheetName,
			createdByName: s.createdByName,
			createdAt: s.createdAt,
			updatedAt: s.updatedAt,
			visibility: s.visibility
		})) : [];

		const { SearchBar, ClearSearchButton } = Search;
		const { ExportCSVButton } = CSVExport;

		const paginationOption = {
			custom: true,
			totalSize: sheets.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};

		return (
			<Card>
				<Card.Header>Sheet Content</Card.Header>
				<Card.Body>
					<PaginationProvider pagination={paginationFactory(paginationOption)}>
						{({ paginationProps, paginationTableProps }) => (
							<ToolkitProvider keyField="id" data={sheets} columns={columns} search bootstrap4>
								{props => (
									<div>
										Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
										<span className="search-cont"><SearchBar {...props.searchProps} /></span>
										<ClearSearchButton className="btn-primary" {...props.searchProps} />
										<ExportCSVButton className="export-csv btn-primary ml-2" {...props.csvProps}>Export to CSV</ExportCSVButton>
										<Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.getSheetContentList()}>Refresh</Button>
										<Link to={`${urlPrefix}/superadmin-api-docs/sheet-content/add`} className="float-right btn btn-primary ml-2">Add Sheet</Link>
										<hr />
										<BootstrapTable
											bordered
											hover
											wrapperClasses="table-responsive"
											classes="w-auto sheet-content-table"
											{...props.baseProps}
											{...paginationTableProps}
											noDataIndication={() => this.state.loading
												? <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>
												: <div>No data available</div>}
										/>
										<PaginationListStandalone {...paginationProps} />
									</div>
								)}
							</ToolkitProvider>
						)}
					</PaginationProvider>
				</Card.Body>

				<Modal size="sm" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, null)}>
					<Modal.Header closeButton>
						<Modal.Title>Delete Sheet</Modal.Title>
					</Modal.Header>
					<Modal.Body>Are you sure you want to delete this sheet?</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={() => this.confirmDelete(false, null)}>Cancel</Button>
						<Button variant="danger" onClick={this.deleteSheet}>Delete</Button>
					</Modal.Footer>
				</Modal>
			</Card>
		);
	}
}

export default SheetContentList;
